import ApiService from '@/services/core/api.service'

const ItemService = {
  async get (query) {
    return ApiService.get(`admin/items?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/items', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/items/${payload.id}`, payload)
  },

  async status (payload) {
    return ApiService.put(`admin/items/status/${payload.id}`, payload)
  }
}

export default ItemService
